import { Button, Grid, Stack } from "@mui/material";
import { ReduxState } from "ra-core";
import { FC, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Content } from "~/components/content/Content";
import CreateOrEdit from "~/controller/CreateOrEdit";
import { useDefaultSavedHandlers } from "~/controller/defaultSavedHandlers";
import WithSave from "~/controller/WithSave";
import { DataInfoTypeResponseDto } from "~/gen/api/encrypt";
import { OdResourcePageProps } from "~/types/resource";
import { LocalMessageLocation, useLocalMessagingRoot } from "~/contexts/LocalMessagingRoot";
import { useLmStatesPropagate } from "~/contexts/LocalMessageHookProtocols/useLmStatesPropagate";
import DataInfoTypeEditor from "~/components/settings/encryption/DatabaseClassificationProtection/DataInfoTypeEditor";
import { useResourceRegister } from "~/utils/resourceRegister";
import { push } from "connected-react-router";
import usePermitGuard from "~/authProvider/usePermitGuard";
import { EDIT_DATA_CLASSIFICATION_ENCRYPTION } from "~/constants";


const CreateDataInfoType: FC<OdResourcePageProps> = (props) => {
  // useResourceRegister({ name: 'file-encrypt-rule-map' })
  // const keyResourceReady = useSelector((store:ReduxState) => !!store.admin.resources['file-encrypt-rule-map'])
  // if (!keyResourceReady) return null

  usePermitGuard([[EDIT_DATA_CLASSIFICATION_ENCRYPTION]])
  return (
    <CreateDataInfoTypeBody {...props} />
  )
}

const CreateDataInfoTypeBody: FC<OdResourcePageProps> = ({
  options, resource,
}) => {
  const dispatch = useDispatch()
  const [states, setStates] = useState({
    dirty: false,
  })
  
  const { LocalMessagingRootHost, subscribe, publish } = useLocalMessagingRoot()
  const { assembleSubStates } = useLmStatesPropagate({ 
    key: 'root',
    asUpperStage: {
      dirtyStateInformed: {
        handler() {
          return (_, dirty) => setStates(v => {
            return v.dirty !== dirty ? {...v, dirty} : v
          })
        },
        deps: []
      }
    }
  }, {subscribe, publish })
  const handleSave = (save: (record:any,callbacks?:any)=>void) => async () => {
    try {
      const result = await assembleSubStates(['editor'])
      const payload = result.editor!
  
      save(payload, {
        onSuccess: ({data}:{data:DataInfoTypeResponseDto}) => {
          dispatch(push(`/${resource}/${data.id}/show`))
        }
      })
    } catch (error) {
      return
    }
  }

  const handlers = useDefaultSavedHandlers("Create Data Info Type")

  return (
    // <Content 
    //   pageName="Create Data Info Type" 
    //   resourceName="Create" 
    //   breadcrumbs={[...(options?.breadcrumbs ?? []), 
    //     { label: 'Data Info Types', path: `/${resource}` }
    //   ]}
    //   mainActions={
    //     <>
    //       <CreateOrEdit resource={resource} basePath="" {...handlers}>
    //         <WithSave 
    //           render={({save, saving}) =>
    //             <Button
    //               color="primary"
    //               disabled={saving || !states.dirty}
    //               variant="contained"
    //               onClick={handleSave(save)}
    //             >
    //               Save
    //             </Button>}
    //         />
    //       </CreateOrEdit>
    //       <Button
    //         color="primary"
    //         variant="outlined"
    //         component={RouterLink}
    //         to={`/${resource}`}
    //       >
    //         Cancel
    //       </Button>
    //     </>
    //   }
    // >
    <>
      <Stack direction="row-reverse" gap={2} marginBottom={-3}>
        <CreateOrEdit resource={resource} basePath="" {...handlers}>
          <WithSave 
            render={({save, saving}) =>
              <Button
                color="primary"
                disabled={saving || !states.dirty}
                variant="contained"
                onClick={handleSave(save)}
              >
                Save
              </Button>}
          />
        </CreateOrEdit>
        <Button
          color="primary"
          variant="outlined"
          component={RouterLink}
          to={`/${resource}`}
        >
          Cancel
        </Button>
      </Stack>
      <Grid container spacing={4} sx={{ mt: 2 }} >
        <Grid item xs={12}>
          <LocalMessagingRootHost>
            <LocalMessageLocation id="editor">
              <DataInfoTypeEditor title="New Data Info Type" />
            </LocalMessageLocation>
          </LocalMessagingRootHost>
        </Grid>
      </Grid>
    </>
    // </Content>
  )
}

export default CreateDataInfoType;
